import { JumpToAnchor } from './jumpToAnchor'

export class TableOfContents {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        block: '.table-of-contents',
        ignoreTableOfContent: '.table-of-contents__ignore',
        listContainer: '.table-of-contents__list-container',
        list: '.table-of-contents__list',
        listAnchor: '.table-of-contents__list a',
        section: '.section',
        titles: ['h1,.display-h1', 'h2,.display-h2', 'h3,.display-h3', 'h4,.display-h4', 'h5,.display-h5', 'h6,.display-h6']
      },
      classes: {
        ignoreTableOfContent: 'table-of-contents__ignore',
        block: 'table-of-contents'
      },
      markup: {
        list: '<div class="dynamic-select__options dynamic-select__options--arrow-down table-of-contents__list"></div>',
        listItem: '<a href="{href}">{content}</a>'
      }
    },
    settings)
  }

  init () {
    this.addElementsToList()
  }

  addElementsToList () {
    const that = this
    const blocks = $(that.options.selectors.block)
    const listContainer = $(that.options.selectors.listContainer)
    const jumpToAnchorClass = new JumpToAnchor()

    listContainer
      .append(that.options.markup.list)

    blocks
      .each(function () {
        const block = $(this)
        const list = block.find(that.options.selectors.list)
        let addTolist = ''

        $(that.options.selectors.section)
          .each(function () {
            const section = $(this)
            const titleElement = that.findTitleInSection(section)
            let id

            if (titleElement !== null) {
              if (section.attr('id')) {
                id = section.attr('id')
              } else {
                id = that.uniqueId()
                section.attr('id', id)
              }

              let newline = that.options.markup.listItem
              newline = newline.replace(/{href}/g, '#' + id)
              newline = newline.replace(/{content}/g, titleElement.text())

              addTolist += newline
            }

            if (section.hasClass(that.options.classes.block)) {
              addTolist = ''
            }
          })

        list.append(addTolist)

        if (list.children().length === 0) {
          block
            .hide()
        }
      })

    $(that.options.selectors.listAnchor)
      .on({
        click: function (event) {
          const element = $(this)
          const hash = element.attr('href').substring(element.attr('href').indexOf('#'))

          if (hash.length > 1) {
            const targetElement = $(hash)

            if (targetElement.length > 0 && targetElement.is(':visible')) {
              event.preventDefault()

              jumpToAnchorClass.jumpToElement(targetElement)
            }
          }
        }
      })
  }

  findTitleInSection (section) {
    const that = this
    let resultTitles

    for (let i = 0; i < that.options.selectors.titles.length; i++) {
      resultTitles = section.find(that.options.selectors.titles[i])

      if (resultTitles.length > 0) {
        for (let j = 0; j < resultTitles.length; j++) {
          if (!resultTitles.eq(j).hasClass(that.options.classes.ignoreTableOfContent) &&
            resultTitles.eq(j).closest(that.options.selectors.ignoreTableOfContent).length === 0) {
            return resultTitles.eq(j)
          }
        }
      }
    }

    return null
  }

  uniqueId () {
    return '_' + Math.random().toString(36).substr(2, 9)
  }
}

export default TableOfContents
